/* src/app/main/pages/services/air-service/air-service-banner/air-service-banner.component.css */
.air-service-banner-row {
  background-image:
    linear-gradient(
      to left,
      rgb(255 255 255 / 0),
      rgb(33 54 84 / 0.5)),
    url(/assets/images/our-services/air-services/air-services-banner.jpg);
}
@media all and (-ms-high-contrast: none) {
  .air-service-banner-row {
    background-image: url(/assets/images/our-services/air-services/air-services-banner.jpg);
  }
}
.service-banner-row {
  height: 91vh;
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 10px solid #F2F2F2;
  background-position: center;
}
.service-banner-row h1 {
  font-size: 56px;
  display: flex;
  align-items: center;
}
.service-banner-icon {
  width: 85px;
  height: auto;
}
.service-banner-row form input[type=text]::-webkit-input-placeholder {
  color: rgb(92 92 92 / 0.8);
}
.service-banner-row form input[type=text]:-ms-input-placeholder {
  color: rgb(92 92 92 / 0.8);
}
.service-banner-row form input[type=text]::placeholder {
  color: rgb(92 92 92 / 0.8);
  font-style: italic;
}
.service-banner-row .shipment-form {
  display: flex;
  width: 100%;
  background-color: #fff;
  align-items: center;
  padding-left: 30px;
}
.service-banner-row .shipment-form .fa-pencil {
  font-size: 26px;
  color: #E8882D;
}
.service-banner-row .shipment-form .form-group {
  width: 84%;
  margin: 12px 0;
}
.service-banner-row .shipment-form .form-group .form-control {
  border: none;
  font-size: 14px;
  padding-left: 10px;
  padding-top: 0;
  padding-bottom: 0;
}
.service-banner-row .shipment-form .form-control:focus {
  box-shadow: none;
}
.service-banner-row .shipment-form .btn-track-now {
  color: #fff;
  background-color: #E8882D;
  font-family: "D-DIN";
  font-size: 18px;
  border-radius: 4px;
  padding: 7px 27px;
}
.nav-tabs {
  width: 50%;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #fff;
  background-color: #E8882D;
  border: none;
  border-radius: 0;
}
.nav-tabs .nav-link {
  color: #fff;
  background-color: #1D1D1D;
  border-radius: 0;
  font-size: 16px;
  box-shadow: 0px 3px 6px #00000029;
  border: none;
  padding: 12px 20px;
  font-weight: 600;
  position: relative;
}
.nav-tabs .nav-link:not(:last-child)::after {
  content: "";
  position: absolute;
  background-color: #797979;
  width: 1px;
  height: 30px;
  top: 8px;
  right: 0;
}
.nav-tabs .nav-link:last-child,
.nav-tabs .nav-link:last-child:hover,
.nav-tabs .nav-link:last-child:focus {
  border-right: none;
}
@media (device-width: 1920px) {
  .service-banner-row {
    height: 83vh;
  }
}
@media (device-width: 1680px) {
  .service-banner-row {
    height: 76vh;
  }
}
@media (device-width: 1600px) {
  .service-banner-row {
    height: 84vh;
  }
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border: none;
}
@media (min-width: 1920px) {
  .service-banner-row .shipment-form .form-group {
    width: 85% !important;
  }
}
@media (min-width: 1440px) {
  .service-banner-row .shipment-form .form-group {
    width: 81%;
    margin: 18px 0;
  }
  .service-banner-row h1 {
    font-size: 82px;
  }
  .service-banner-row .nav-tabs {
    width: 65%;
  }
  .service-banner-row .nav-tabs .nav-link {
    font-size: 24px;
  }
  .nav-tabs .nav-link:not(:last-child)::after {
    height: 44px;
  }
  .service-banner-row .shipment-form .form-group .form-control {
    font-size: 19px;
  }
  .service-banner-row .shipment-form .btn-track-now {
    font-size: 25px;
    padding: 7px 32px;
  }
  .service-banner-row .shipment-form .fa-pencil {
    font-size: 32px;
  }
  .service-banner-icon {
    width: auto;
    height: auto;
  }
}
@media (device-width: 1440px) {
  .service-banner-row h1 {
    font-size: 62px;
    display: flex;
    align-items: center;
  }
  .nav-tabs .nav-link {
    font-size: 20px;
  }
  .service-banner-row .shipment-form .btn-track-now {
    font-size: 20px;
    padding: 8px 27px;
  }
  .service-banner-row {
    height: 78vh;
  }
}
@media (device-width: 1280px) {
  .service-banner-row {
    height: 75vh;
  }
}
@media (min-device-width: 1024px) {
  .service-banner-row .shipment-form .form-group .form-control {
    font-size: 18px;
  }
}
@media (device-width: 1024px) {
  .service-banner-row .shipment-form .form-group {
    width: 81%;
  }
}
@media (device-width: 768px) {
  .service-banner-row .nav-tabs {
    width: 70%;
  }
  .service-banner-row .shipment-form .form-group {
    width: 75%;
  }
  .service-banner-icon {
    width: 100px;
  }
}
@media (max-width: 768px) {
  .service-banner-row {
    background-position: center;
  }
}
@media (max-width: 767px) {
  .service-banner-icon {
    width: 65px;
  }
}
@media (max-width: 560px) {
  .service-banner-row {
    height: 390px;
  }
  .service-banner-row .fa-plane {
    font-size: 35px;
    padding: 10px;
  }
  .service-banner-row h1 {
    font-size: 26px;
  }
  .nav-tabs {
    width: 100%;
  }
  .nav-tabs .nav-link {
    font-size: 13px;
    padding: 12px 2px;
  }
  .service-banner-row .shipment-form {
    display: flex;
    width: 100%;
    background-color: #fff;
    align-items: center;
    padding-left: 10px;
  }
  .service-banner-row .shipment-form .form-group {
    width: 62%;
  }
  .service-banner-row .shipment-form .form-group .form-control {
    font-size: 13px;
  }
  .service-banner-row .shipment-form .btn-track-now {
    padding: 7px 10px;
    font-size: 14px;
  }
}
@media (min-width: 411px) and (max-width: 414px) {
  .service-banner-row .shipment-form .form-group {
    width: 69%;
  }
}
@media (device-width: 375px) {
  .service-banner-row .shipment-form .form-group {
    width: 67%;
  }
}
@media (max-width: 350px) {
  .service-banner-row .shipment-form .btn-track-now {
    padding: 5px 8px;
    font-size: 14px;
  }
  .nav-tabs .nav-link {
    font-size: 11px;
  }
}
/*# sourceMappingURL=air-service-banner.component.css.map */
